import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import 'react-phone-input-2/lib/style.css'
import "./styles/globals.css";
// import "./styles/core.css";
// import "./styles/theme-default.css";
import "react-toastify/dist/ReactToastify.css";
// import 'react-quill/dist/quill.snow.css'
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "../src/context/theme/ApiContext";
import { ThemeContextProvider } from "../src/context/theme/ThemeContext";
import { toast, ToastContainer } from "react-toastify";
import { SettingContextProvider } from "../src/context/Setting/Setting";
import { MembershipContextProvider } from "./context/membership/membership";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <SettingContextProvider>
    <ThemeContextProvider>
      <AuthContextProvider>
        <MembershipContextProvider>
          <App />
        </MembershipContextProvider>
      </AuthContextProvider>
      <ToastContainer />
    </ThemeContextProvider>
  </SettingContextProvider>
  //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
